module.exports = __webpack_public_path__ + "media/components/Application/Contacts/New/logo-f78535a0a1669d6adb8d4ecc599d9ae7.png";